import StoreUtils from './StoreUtils';
import { INIT_REDUCER } from '../shared/SharedActions';

/**
 * Provede zpracování store, který může obsahovat area a vrátí upraený store.
 * Musí být voláno jen s platnou areou.
 * @param state state
 * @param action akce
 * @return upravený store
 */
export default function processAreaStores(state: any, action: {area: string, type: string, store?: object}) {
    const areaItems = action.area.split('.');

    const newAction = {
        ...action,
        area: areaItems.slice(1).join('.'),
    };
    if (areaItems[0] === '*') {
        return StoreUtils.processAllStores(state, newAction);
    } else if (state[areaItems[0]]) {
        return StoreUtils.processStore(areaItems[0], state, newAction);
    } else if (action.type === INIT_REDUCER) {  // inicializace shared reduceru pod nějakým area group
        if (areaItems.length > 1) { // je jich víc, zatím nemáme implementováno, měl by se založit podřízený area group reducer
            throw new Error('Neimplementováno');
        } else {
            return {
                ...state,
                [areaItems[0]]: {
                    ...action.store,
                },
            };    // inicializujeme ten z akce
        }
    } else {
        return state;
    }
}
